import { Injectable } from '@angular/core';
import { UrlFactory } from './url-factory';

@Injectable({ providedIn: 'root' })
export class ElevateSurveyGateway {
  constructor(private _urlFactory: UrlFactory) {}

  surveyTaskUrl(tag: string = 'beh'): string {
    return this._urlFactory.createUrl('elevateSurvey', '/task', {
      _tag: tag,
      _sort: 'status',
      _count: 1,
    });
  }

  nextQuestionUrl(
    questionnaireId: string,
    tag: string = 'beh',
    eligibility?: string,
    valueId?: string,
  ): string {
    return this._urlFactory.createUrl(
      'elevateSurvey',
      `questionnaire/${questionnaireId}/$next-question`,
      {
        _tag: tag,
        _eligibility: eligibility,
        _valueId: valueId,
      },
    );
  }

  surveyQuestionnaireResponseUrl(responseId: string): string {
    return this._urlFactory.createUrl(
      'elevateSurvey',
      `questionnaireResponse/${responseId}`,
    );
  }
}
